import { RefObject, useEffect, useState } from 'react';

import { CareerType } from '~features/company/SalaryInfo/types';

interface UseInfiniteLoadingDetectorParams {
  ref: RefObject<HTMLLIElement>;
  options?: IntersectionObserverInit;
}

export function useInfiniteLoadingDetector({
  ref,
  options = {},
}: UseInfiniteLoadingDetectorParams) {
  const [isVisible, setVisible] = useState<boolean>();

  useEffect(() => {
    let observer: IntersectionObserver;
    if (ref && ref.current) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
          } else {
            setVisible(false);
          }
        });
      }, options);

      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return isVisible;
}

export function useGetUserInfo(type: CareerType, userName: string, career: number) {
  if (type === '신입') {
    return `신입 ${userName}님`;
  }

  if (career > 10) {
    return `경력 10년 초과 ${userName}님`;
  }

  return `경력 ${career}년 ${userName}님`;
}
